import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@radix-ui/themes";
import recoverService from "../service/recoverService";

export default function RecoverView() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [step, setStep] = useState(1);

  const apiGateway = {
    user_pool_id: "us-east-1_af2GRumEQ",
    app_client_id: "28qrq8nr4tih8odvf11ufs1a9s",
  };

  const sendCode = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");

    const response = await recoverService.forgotPassword(email, apiGateway);

    if (response.status === "Success") {
      setMessage("Código enviado para o email.");
      setStep(2);
    } else {
      setMessage(response.error || "Erro ao enviar código.");
    }
  };

  const verifyCode = (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");

    if (!code) {
      setMessage("Código inválido.");
      return;
    }

    setStep(3);
  };

  const resetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");

    if (newPassword !== confirmPassword) {
      setMessage("As senhas não coincidem.");
      return;
    }

    const response = await recoverService.confirmPasswordReset(code, newPassword, email, apiGateway);

    if (response.status === "Success") {
      setMessage("Senha redefinida com sucesso!");
      setTimeout(() => navigate("/login"), 2000);
    } else {
      setMessage(response.error || "Erro ao redefinir senha.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Card className="w-96 p-8 bg-white shadow-lg rounded-lg">
        <h1 className="text-2xl font-semibold text-[#2294ae] text-center mb-6">
          {step === 1 ? "Recuperar Senha" : step === 2 ? "Verificar Código" : "Nova Senha"}
        </h1>

        {message && (
          <p className={`text-center mb-4 ${message.includes("sucesso") ? "text-green-500" : "text-red-500"}`}>
            {message}
          </p>
        )}

        {step === 1 && (
          <form onSubmit={sendCode}>
            <label className="block text-lg font-medium text-[#2294ae] mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]"
              placeholder="Digite seu email"
              required
            />
            <button
              type="submit"
              className="w-full mt-4 py-2 bg-[#2294ae] text-white font-bold rounded-md hover:bg-[#1c7c92] focus:outline-none focus:ring-2 focus:ring-[#2294ae]"
            >
              Enviar Código
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={verifyCode}>
            <label className="block text-lg font-medium text-[#2294ae] mb-2">Código</label>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]"
              placeholder="Digite o código"
              required
            />
            <button
              type="submit"
              className="w-full mt-4 py-2 bg-[#2294ae] text-white font-bold rounded-md hover:bg-[#1c7c92] focus:outline-none focus:ring-2 focus:ring-[#2294ae]"
            >
              Verificar Código
            </button>
          </form>
        )}

        {step === 3 && (
          <form onSubmit={resetPassword}>
            <label className="block text-lg font-medium text-[#2294ae] mb-2">Nova Senha</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]"
              placeholder="Digite sua nova senha"
              required
            />

            <label className="block text-lg font-medium text-[#2294ae] mt-4 mb-2">Confirmar Senha</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-4 py-2 border rounded-md text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#2294ae]"
              placeholder="Confirme sua nova senha"
              required
            />

            <button
              type="submit"
              className="w-full mt-4 py-2 bg-[#2294ae] text-white font-bold rounded-md hover:bg-[#1c7c92] focus:outline-none focus:ring-2 focus:ring-[#2294ae]"
            >
              Redefinir Senha
            </button>
          </form>
        )}
      </Card>
    </div>
  );
}